import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "anchor fw-bolder mb-5" }, [
  /*#__PURE__*/_createVNode("a", { href: "#size-control" }),
  /*#__PURE__*/_createTextVNode(" Size control ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, [
  /*#__PURE__*/_createTextVNode(" All components in a Form inherit their "),
  /*#__PURE__*/_createVNode("code", null, "size"),
  /*#__PURE__*/_createTextVNode(" attribute from that Form. Similarly, FormItem also has a "),
  /*#__PURE__*/_createVNode("code", null, "size"),
  /*#__PURE__*/_createTextVNode(" attribute. ")
], -1)
const _hoisted_4 = { class: "rounded border p-10" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("-")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Create")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Cancel")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_el_col = _resolveComponent("el-col")
  const _component_el_time_picker = _resolveComponent("el-time-picker")
  const _component_el_checkbox_button = _resolveComponent("el-checkbox-button")
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")
  const _component_el_radio = _resolveComponent("el-radio")
  const _component_el_radio_group = _resolveComponent("el-radio-group")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_form = _resolveComponent("el-form")
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_el_form, {
        ref: "form",
        model: _ctx.sizeForm,
        "label-width": "120px",
        size: "mini"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, { label: "Activity name" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.sizeForm.name,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.sizeForm.name = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "Activity zone" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.sizeForm.region,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.sizeForm.region = $event)),
                placeholder: "please select your zone"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    label: "Zone one",
                    value: "shanghai"
                  }),
                  _createVNode(_component_el_option, {
                    label: "Zone two",
                    value: "beijing"
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "Activity time" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 11 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_date_picker, {
                    type: "date",
                    placeholder: "Pick a date",
                    modelValue: _ctx.sizeForm.date1,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.sizeForm.date1 = $event)),
                    style: {"width":"100%"}
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, {
                class: "line",
                span: 2
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 11 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_time_picker, {
                    placeholder: "Pick a time",
                    modelValue: _ctx.sizeForm.date2,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.sizeForm.date2 = $event)),
                    style: {"width":"100%"}
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "Activity type" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_checkbox_group, {
                modelValue: _ctx.sizeForm.type,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.sizeForm.type = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_checkbox_button, {
                    label: "Online activities",
                    name: "type"
                  }),
                  _createVNode(_component_el_checkbox_button, {
                    label: "Promotion activities",
                    name: "type"
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "Resources" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_radio_group, {
                modelValue: _ctx.sizeForm.resource,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.sizeForm.resource = $event)),
                size: "medium"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio, {
                    border: "",
                    label: "Sponsor"
                  }),
                  _createVNode(_component_el_radio, {
                    border: "",
                    label: "Venue"
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { size: "large" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _ctx.onSubmit
              }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_el_button, null, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"]),
      _createVNode(_component_CodeHighlighter, {
        "field-height": 400,
        lang: "html"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.code7), 1)
        ]),
        _: 1
      })
    ])
  ]))
}